import React from 'react';
import { Fade, Zoom } from 'react-awesome-reveal';
import './NextSteps.css';

const NextSteps = () => {
  const steps = [
    {
      number: '01',
      title: 'Initial Consultation',
      icon: 'fa fa-comments',
      color: '#628141',
      items: [
        'Schedule a consultation',
        'Discuss your vision',
        'Define your budget'
      ]
    },
    {
      number: '02',
      title: 'Portfolio Review',
      icon: 'fa fa-images',
      color: '#0aa514',
      items: [
        'Review our portfolio',
        'Explore past projects',
        'Gather inspiration ideas'
      ]
    },
    {
      number: '03',
      title: 'Project Finalization',
      icon: 'fa fa-check-circle',
      color: '#628141',
      items: [
        'Finalize project details',
        'Set timelines',
        'Confirm materials'
      ]
    }
  ];

  return (
    <div className="next-steps-section container-xxl py-6">
      <div className="container">
        <Fade direction="down" triggerOnce>
          <div className="text-center mb-5">
            <p className="text-primarys text-uppercase mb-2">// Getting Started</p>
            <h1 className="display-6 mb-4">Next Steps</h1>
            <p className="lead mb-0">
              Let's begin your transformation journey with these simple steps
            </p>
          </div>
        </Fade>

        <div className="next-steps-container">
          {steps.map((step, index) => (
            <Fade
              key={index}
              direction="up"
              delay={index * 200}
              triggerOnce
            >
              <div className="next-step-card">
                <div className="step-header">
                  <div 
                    className="step-number"
                    style={{ 
                      backgroundColor: step.color,
                      boxShadow: `0 4px 20px ${step.color}40`
                    }}
                  >
                    {step.number}
                  </div>
                  <Zoom delay={index * 200 + 100} triggerOnce>
                    <div 
                      className="step-icon-wrapper"
                      style={{ 
                        backgroundColor: `${step.color}15`,
                        borderColor: `${step.color}30`
                      }}
                    >
                      <i 
                        className={step.icon}
                        style={{ color: step.color }}
                      ></i>
                    </div>
                  </Zoom>
                </div>

                <h3 className="step-title">{step.title}</h3>

                <ul className="step-items">
                  {step.items.map((item, itemIndex) => (
                    <Fade
                      key={itemIndex}
                      direction="left"
                      delay={index * 200 + (itemIndex + 1) * 100}
                      triggerOnce
                    >
                      <li className="step-item">
                        <i 
                          className="fa fa-check"
                          style={{ color: step.color }}
                        ></i>
                        <span>{item}</span>
                      </li>
                    </Fade>
                  ))}
                </ul>

                <div 
                  className="step-divider"
                  style={{ backgroundColor: `${step.color}20` }}
                ></div>
              </div>
            </Fade>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NextSteps;


